import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import VisionSection from './components/VisionSection';
import PromiseSection from './components/PromiseSection';
import StrengthsSection from './components/StrengthsSection';
import RTKSection from './components/RTKSection';
import RelationshipSection from './components/RelationshipSection';
import BusinessSection from './components/BusinessSection';
import LocationsSection from './components/LocationsSection';
import AboutCTASection from './components/AboutCTASection';

export default function About() {
  useEffect(() => {
    // SEO設定
    document.title = 'IDS教習所グループについて｜会社概要・沿革｜佐賀・福岡・鹿児島｜IDS教習所';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'IDS教習所グループは、佐賀県多久市・佐賀市・鹿児島県日置市に3拠点を展開し、DJI農業ドローン、FJD・EFIX自動操舵システム、Farmo水管理システムを販売。農業ドローン協議会認定スクール運営、DJI推薦修理センター認定。2020年設立。累計導入実績300台以上。地域密着型のスマート農業支援企業です。');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'IDS教習所グループ,会社概要,沿革,佐賀県,多久市,佐賀市,鹿児島県,日置市,株式会社アイテム,九三エンジニアリング,株式会社エコナーセリー,農業ドローン協議会,DJI推薦修理センター,スマート農業,地域密着');
    }

    // 構造化データ
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "AboutPage",
          "name": "IDS教習所グループについて",
          "description": "IDS教習所グループは、佐賀県多久市・佐賀市・鹿児島県日置市に3拠点を展開し、DJI農業ドローン、FJD・EFIX自動操舵システム、Farmo水管理システムを販売。",
          "url": `${siteUrl}/about`,
          "mainEntity": {
            "@type": "Organization",
            "name": "IDS教習所グループ",
            "description": "地域密着型のスマート農業支援企業"
          }
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "ホーム",
              "item": siteUrl
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "会社概要",
              "item": `${siteUrl}/about`
            }
          ]
        }
      ]
    });
    document.head.appendChild(script);

    // Add H1 tag for about page
    const h1 = document.createElement('h1');
    h1.textContent = 'IDS教習所グループについて';
    h1.style.position = 'absolute';
    h1.style.left = '-9999px';
    h1.style.fontSize = '1px';
    document.body.appendChild(h1);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (document.body.contains(h1)) {
        document.body.removeChild(h1);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AboutHeroSection />
        <VisionSection />
        <PromiseSection />
        <StrengthsSection />
        <RTKSection />
        <RelationshipSection />
        <BusinessSection />
        <LocationsSection />
        <AboutCTASection />
      </main>
      <Footer />
    </div>
  );
}
